// extracted by mini-css-extract-plugin
module.exports = {"button":"_3al3gpU","message":"_1qUb52a","title":"_2BqJIVh","errorMessage":"_1Zzu4sT"};